import SearchLookup from "@/components/SearchLookup";
import { Button, Form } from "antd";
import React, {useState} from "react";
import { facility_category_options } from "./FacilityFormFields";
import CompanyLookup from "@/containers/Lookup/CompanyLookup";
import { AutoSearchSelect } from "@/components/auto-search";
import { api } from "@/redux/api";
import { jsforceResponse } from "@/config/httpService";
import _ from "lodash";
import Select from "@components/ResponsiveSelect";

const fetchCompanyOptions = async (name) => {
    const result = await api.filterCompany(`name=${name}`);
    const res = jsforceResponse(result, '', false, true)
    const results = _.get(res, 'data.results', []);

    return results.map(item => ({
        label: item.name,
        value: item.name
    }))
}

export const FacilityFilters = (props) => {

    const formRef = React.useRef()

    const categoryFilter = () => {
        return (
            <AutoSearchSelect
                request={(name) => {
                    if(!name) {
                        return facility_category_options
                    }else {
                        return facility_category_options.filter(item => item.label.toLowerCase().includes(name.toLowerCase()))
                    }
                }}
                placeholder="Category"
            />
        )
    }

    const companyFilter = () => {
        return (
            <AutoSearchSelect
                request={fetchCompanyOptions}
                placeholder="Company"
            />
        )
    }

    // function handleSubmit(e) {
    //     console.log('submit', e)
    //     props.handleFilter(e)
    // }

    const handleValuesChange = (_, allFields) => {
        props.handleFilter(allFields)
    }

    return <Form
        id="myForm"
        layout="inline"
        onValuesChange={handleValuesChange}
        ref={formRef}
        style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}
                        autoComplete="off">

        <Form.Item name={'Company'} style={{ marginBottom: 0, width: 220 }}>
            {companyFilter()}
        </Form.Item>

        <Form.Item name={'Category'} style={{ marginBottom: 0, width: 220 }}>
            {categoryFilter()}
        </Form.Item>
    </Form>

}
